import { useQuery } from '@tanstack/react-query';
import { healthApi } from '../api/health';

export const useServiceStatus = () => {
  return useQuery({
    queryKey: ['health', 'services'],
    queryFn: () => healthApi.getServiceStatus(),
    refetchInterval: 30000, // Refresh every 30 seconds
  });
};

export const useSystemOverview = () => {
  return useQuery({
    queryKey: ['health', 'overview'],
    queryFn: () => healthApi.getSystemOverview(),
  });
};
